import type { FlexProps } from "@chakra-ui/react";
import { Flex, Table, TableContainer, Tbody, Td, Th, Thead, Tr } from "@chakra-ui/react";
import type { DataTable } from "@/types";
import { ContentBlock } from "@/components/ContentBlock/ContentBlock";
import { htmlify } from "@/services/utils";
import type { FundDetailLayoutComponentProps } from "@/types/fundDetailLayout";

export interface FundBestWorstPerformanceTablePanelProps extends FlexProps {
	heading?: string;
	tooltip?: string;
	data: DataTable;
}

export const FxBestWorstPerformancePanel = (props: FundDetailLayoutComponentProps) => {
	const { dashboard } = props;

	if (!dashboard.fxBestWorstPerformancePanel) {
		return null;
	}

	const { heading, tooltip, data } = dashboard.fxBestWorstPerformancePanel;

	return (
		<ContentBlock
			id="fxBestWorstPerformancePanel"
			data-testid="FxBestWorstPerformancePanel"
			heading={htmlify(heading)}
			tooltip={htmlify(tooltip)}
		>
			<Flex direction="row">
				<TableContainer>
					<Table variant="striped" colorScheme="gray" width="inherit">
						{data.header && (
							<Thead>
								<Tr>
									{data.header.map((value, index) => {
										return (
											<Th scope="col" key={index} overflowWrap="anywhere" whiteSpace="break-spaces">
												{htmlify(value)}
											</Th>
										);
									})}
								</Tr>
							</Thead>
						)}
						<Tbody>
							{data.rows.map((row, index) => {
								return (
									<Tr key={index}>
										{row.map((value, index) => {
											return (
												<Td key={index} overflowWrap="anywhere" whiteSpace="break-spaces">
													{htmlify(value)}
												</Td>
											);
										})}
									</Tr>
								);
							})}
						</Tbody>
					</Table>
				</TableContainer>
			</Flex>
		</ContentBlock>
	);
};
